import { createSlice,createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import {BASE_URL} from '../../utils/commonUrl'
const initState = {
    isLoading:false,
    message:'',
    competencyOpinion:[]
}

export const fetchCompetencyOpinion = createAsyncThunk('competencyOpinion/getall', async () => {
    const response = await axios.get(`${BASE_URL}/api/competencyOpinion`)
    return response.data
  })


let userSlice = createSlice({
  name:'competencyOpinion',
  initialState:initState,
  extraReducers:(builder)=>{
      builder
      .addCase(fetchCompetencyOpinion.pending,(state)=>{
          state.isLoading = true
      })
      .addCase(fetchCompetencyOpinion.fulfilled,(state,action)=>{
          state.isLoading = false
          state.competencyOpinion = action.payload
      })
      .addCase(fetchCompetencyOpinion.rejected,(state,payload)=>{
          state.isLoading = false
          state.message = payload.data.message
      })

  },
  reducers:{
      
  
  }
})

//export const {} = userSlice.actions;

export default userSlice.reducer;